import React from "react";
import { Form, Input } from "antd";
import { DeleteIcon, PlusIcon } from "../icons";
import { useTranslation } from "react-i18next";

const TextArea = Input.TextArea;

export default function CoreSellingPointsForm({
  name = "coreFeature",
}: {
  name?: string | string[];
}) {
  const { t } = useTranslation();
  return (
    <div className="">
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            <div className="border border-borderColor rounded-lg overflow-hidden">
              <div className="flex h-[48px] bg-[#FAFAF9] items-center border-b border-borderColor">
                <div className="text-font&icon-secondary text-xs font-medium w-[64px] text-center">
                  {t('components.coreSellingPointsForm.number')}
                </div>
                <div className="justify-start text-font&icon-secondary text-xs font-medium leading-none">
                  {t('components.coreSellingPointsForm.description')}
                </div>
              </div>
              {fields.map((field, index) => (
                <div className={`flex items-center my-4 pr-4`} key={field.key}>
                  <div className="justify-start w-[64px] text-center text-sm font-normal leading-snug text-neutral-500">
                    {index + 1}
                  </div>
                  <Form.Item
                    key={field.key}
                    name={[field.name]}
                    rules={[
                      {
                        required: true,
                        message: t('components.coreSellingPointsForm.pleaseInputCoreProductFeatures'),
                      },
                    ]}
                    className="w-full mb-0"
                  >
                    <TextArea size="large" autoSize={{ minRows: 1, maxRows: 5 }} />
                  </Form.Item>
                  {fields?.length > 1 && (
                    <span
                      className="cursor-pointer w-[32px] flex justify-center items-center"
                      onClick={() => remove(field.name)}
                    >
                      <DeleteIcon className="delete" />
                    </span>
                  )}
                </div>
              ))}
            </div>
            <Form.Item className="mb-0 mt-6">
              <div
                className="flex items-center text-primary cursor-pointer text-sm font-medium gap-1"
                onClick={() => add("")}
              >
                <PlusIcon className="text-primary" />
                <span>{t('components.coreSellingPointsForm.add')}</span>
              </div>
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
}
